module.exports = __webpack_public_path__ + "img/0Q3B3793_FoamcoreMatted.00841153.jpg";